import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppState } from './app-state'

@NgModule({
  declarations: [],
  imports: [
    CommonModule, BrowserModule
  ],
  providers: [ AppState ],
  exports: [
  ]
})
export class CoreModule { 

}
